import React from "react";

import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import {
  SHIPPING_LINES_URL,
  DELETE_SHIPPING_LINE,
  SAVE_SHIPPING_LINE,
} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import ItemValidationSchema from "@Utils/Validations/ItemValidationSchema";

function ShippingLinesListing() {
  const attributes = [
    { key: "shippingLineName", label: "Shipping Line Name", flex: 2 },
  ];

  const validationSchema = ItemValidationSchema(attributes[0].key,attributes[0].label);
  return (
    <GenericItemsListing
      items_URL={SHIPPING_LINES_URL}
      SAVE_Item={SAVE_SHIPPING_LINE}
      DELETE_Item={DELETE_SHIPPING_LINE}
      title="Shipping Lines"
      name="Shipping Line"
      icon={<LocalShippingRoundedIcon fontSize="large" color="white" />}
      attributes={attributes}
      validationSchema={validationSchema}
        uniqueId={"shippingLineId"}
    />
  );
}

export default ShippingLinesListing;
